import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

const VerificationReceivedPopUp = (props) => {
  const {
    setVerificationReceivedPopUp,
    verificationReceivedPopUp,
    week,
    month,
    markReceived
  } = props;

  const handleYes = () => {
    markReceived();
    setVerificationReceivedPopUp(false);
  };

  const handleNo = () => {
    setVerificationReceivedPopUp(false);
  };

  return (
    <Dialog fullWidth={true} maxWidth={'xs'} open={verificationReceivedPopUp}>
      <DialogContent dividers>
        <Typography variant='h6'>Would you like the system to mark the verification record for the week of {week} and the month of {month} as Received? </Typography>
      </DialogContent>
      <DialogActions>
        <Button variant='contained' onClick={handleYes}>
          Yes
        </Button>
        <Button variant='contained' onClick={handleNo}>
          No
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default VerificationReceivedPopUp;
